import { ObjectSignal } from "../../signal/ObjectSignal";
import { IValueComponent } from "./interfaces/IValueComponent";
import { ValueChangerController } from "./ValueChangerController";

export class AValueComponent implements IValueComponent {
    protected _parent: ValueChangerController;

    private _value: number;
    private _minValue: number;
    private _maxValue: number;
    protected isDisposed: boolean = false;
    public updatedByUserSignal: ObjectSignal = new ObjectSignal();

    constructor(parent: ValueChangerController, minValue: number, maxValue: number) {
        this._parent = parent;
        this._minValue = minValue;
        this._maxValue = maxValue;
        this._value = minValue;
        this.isDisposed = false;
    }

    public updateValue(value: number): void {
        this._value = value;
    }

    public dispatchUpdateByUserSignal(newValue: number): void {
        this.updatedByUserSignal.signal(newValue);
    }

    public dispose(): void {
        if (!this.isDisposed) {
            this.updatedByUserSignal.removeAll();
            this.isDisposed = true;
        }
    }

    public getUpdateByUserSignal(): ObjectSignal {
        return this.updatedByUserSignal;
    }

    public get value(): number {
        return this._value;
    }

    public get minValue(): number {
        return this._minValue;
    }

    public get maxValue(): number {
        return this._maxValue;
    }
}
